var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from "mobx";
import { isArray, isUndefined, isNull } from "lodash-es";
var LoadingData = /** @class */ (function () {
    function LoadingData(initData) {
        this.isLoading = true;
        this.isNoData = false;
        this.data = null;
        this.data = initData;
    }
    LoadingData.prototype.get = function () {
        return this.data;
    };
    LoadingData.prototype.setLoading = function () {
        this.isLoading = true;
    };
    LoadingData.prototype.setUnLoading = function () {
        this.isLoading = false;
    };
    LoadingData.prototype.setIsNoData = function (isNoData) {
        this.isNoData = isNoData;
    };
    LoadingData.prototype.set = function (data) {
        this.setLoadedData(data);
    };
    LoadingData.prototype.setLoadedData = function (data) {
        this.data = data;
        this.isLoading = false;
        var isArrayNoData = isArray(data) && data.length <= 0;
        var isEmpty = isNull(data) || isUndefined(data);
        if (isArrayNoData || isEmpty) {
            this.isNoData = true;
        }
    };
    __decorate([
        observable
    ], LoadingData.prototype, "isLoading", void 0);
    __decorate([
        observable
    ], LoadingData.prototype, "isNoData", void 0);
    __decorate([
        observable
    ], LoadingData.prototype, "data", void 0);
    __decorate([
        action.bound
    ], LoadingData.prototype, "setLoading", null);
    __decorate([
        action.bound
    ], LoadingData.prototype, "setUnLoading", null);
    __decorate([
        action.bound
    ], LoadingData.prototype, "setIsNoData", null);
    __decorate([
        action.bound
    ], LoadingData.prototype, "set", null);
    __decorate([
        action.bound
    ], LoadingData.prototype, "setLoadedData", null);
    return LoadingData;
}());
export default LoadingData;
